import { Constants } from '../common/Constants';
import * as InternalTypes from '../common/InternalTypes';

export class RuntimeConfig {
	private readonly _useApi: boolean = true;
	private readonly _domElementId: string;
	private readonly _daysUntilLocalStateExpiry: number = Constants.DEFAULTS.DAYS_UNTIL_STATE_EXPIRY;

	constructor(runtimeConfig?: InternalTypes.RuntimeConfig) {
		//Check if input exists else just instantiate with defaults
		if (runtimeConfig?.useApi !== undefined) {
			this._useApi = runtimeConfig.useApi;
		}
		if (runtimeConfig?.domElementId) {
			this._domElementId = runtimeConfig.domElementId;
		}
		if (runtimeConfig?.daysUntilLocalStateExpiry) {
			this._daysUntilLocalStateExpiry = runtimeConfig.daysUntilLocalStateExpiry;
		}
	}

	get useApi() {
		return this._useApi;
	}

	get domElementId() {
		return this._domElementId;
	}

	get daysUntilLocalStateExpiry() {
		return this._daysUntilLocalStateExpiry;
	}
}
